import React, { Fragment, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

import PageTitle from "../components/pagetitle/PageTitle";
import TrackEnquiry from "../components/TrackEnquiry/TrackEnquiry";

const TrackEnquiryPage = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <Fragment>
      <Helmet>
        <title>Track Your Book | Print Printers</title>
        <meta
          name="description"
          content="Track the progress of your Print Printers quote request using your reference number."
        />
        <link rel="canonical" href="https://printprinters.com/track-your-book" />
        {/* A status lookup has no search value and the ?ref= parameter is customer-specific. */}
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <PageTitle pageTitle="Status" pagesub="Track Your Book" />

      <TrackEnquiry />
    </Fragment>
  );
};

export default TrackEnquiryPage;
